


































import { Component, Vue, Provide, Prop } from 'vue-property-decorator';
import Order from '@/components/Invoicing/Order/Order.vue';
import { GET_ORDER } from '@/queries/Order';
import { generateUID } from '../utils/utils';
import { cloneDeep } from 'lodash';
import { DocumentShowType } from '@/components/Invoicing/Shared/DocumentHeader.vue';

@Component({
  components: {
    Order,
  },
})
export default class OrdersPdf extends Vue {
  @Prop({ type: String, required: true }) private type!: DocumentShowType;

  public GET_ORDER = GET_ORDER;

  @Provide() public isPdf = true;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public modifyOrderData = (data: {order: any}) => {
    if (!data.order.car) data.order.car = { id: null };
    if (!data.order.project) data.order.project = { id: null };
    if (!data.order.department) data.order.department = { id: null };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data.order.orderLines = data.order.orderLines.map((line: any) => {
      if (!line.car) line.car = { id: null };
      if (!line.project) line.project = { id: null };
      if (!line.department) line.department = { id: null };
      if (!line.product) line.product = { id: null };
      if (!line.$_UID) line.$_UID = generateUID();
      return line;
    });
    return cloneDeep(data);
  };
}
